import React, { useState, useEffect, useRef } from "react";
import { useQuery } from "react-query";
import {
  I2cButton,
  I2cTab,
  I2cTabGroup,
  I2cTabPanel,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useParams } from "react-router-dom";
import DataTable from "../../Components/DataTable/DataTable";
import UserManagmentService from "../../Services/UsermanagmentService";
import "./SalesRequest.scss";

const AssignProjectUsers = ({
  closeModal = () => null,
  userTableDataApi,
  userTableDataApiExternal,
}) => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(false);
  const [usersType, setUsersType] = useState("internal");
  const [users, setUsers] = useState([]);
  const { id: userId } = useParams();

  const {
    data,
    error,
    isLoading,
    refetch: refetchUsers,
  } = useQuery(
    ["getProjectUsers", page],
    () => UserManagmentService.getProjectUsers(page),
    {
      refetchOnWindowFocus: false,
    },
  );
  useEffect(() => {
    if (data) {
      const userData = Array.isArray(data.data.data) ? data.data.data : [];
      const filteredUsers = userData
        .filter((user) => {
          if (usersType === "internal") {
            return user.role !== "client";
          } else {
            return user.role === "client";
          }
        })
        .filter((user) => user.role !== "viewonly");
      setUsers(filteredUsers);
      setTotal(filteredUsers.length);
    } else {
    }
  }, [data, usersType]);

  useEffect(() => {
    if (data && data.data && Array.isArray(data.data.data)) {
      // Filter users based on role when usersType changes
      const filteredUsers = data.data.data
        .filter((user) => {
          if (usersType === "internal") {
            return user.role !== "client";
          } else {
            return user.role === "client";
          }
        })
        .filter((user) => user.role !== "viewonly");

      setUsers(filteredUsers);
      setTotal(filteredUsers.length);
    }
  }, [usersType]);
  const columnDefs = [
    {
      field: "",
      headerName: " ",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      flex: 1,
      minWidth: 68,
      suppressMenu: true,
    },
    {
      field: "name",
      headerName: "Name",
      sortable: true,
      flex: 1,
      minWidth: 178,
      suppressMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      sortable: true,
      flex: 1,
      minWidth: 178,
      suppressMenu: true,
    },
    {
      field: "designation",
      headerName: "Designation",
      sortable: true,
      flex: 1,
      minWidth: 178,
      suppressMenu: true,
    },
  ];

  const noData = [
    {
      heading: "No records found",
      description: "No records were found.",
      type: "noData",
      icon: "outline-info-circle",
      iconColor: "var(--i2c-color-primary-600)",
    },
  ];

  return (
    <React.Fragment>
      <div className="dTable_assignUsers">
        <I2cTabGroup size="small" primary className="user_dialog_tab">
          <I2cTab
            slot="nav"
            panel="internal"
            onClick={() => setUsersType("internal")}
          >
            Internal
          </I2cTab>
          <I2cTab
            slot="nav"
            panel="external"
            onClick={() => setUsersType("external")}
          >
            External
          </I2cTab>
          <I2cTabPanel name="internal">
            <DataTable
              columnDefs={columnDefs}
              rowData={users}
              title=""
              noData={noData}
              pageSize={10}
              currentPage={page}
              setCurrentPage={setPage}
              total={total}
              tableDataApi={userTableDataApi}
              description=""
              closeModal={closeModal}
              rowSelection="single"
            />
          </I2cTabPanel>
          <I2cTabPanel name="external">
            <DataTable
              columnDefs={columnDefs}
              rowData={users}
              title=""
              noData={noData}
              pageSize={10}
              currentPage={page}
              setCurrentPage={setPage}
              total={total}
              description=""
              tableDataApi={userTableDataApiExternal}
              closeModal={closeModal}
              rowSelection="single"
            />
          </I2cTabPanel>
        </I2cTabGroup>
      </div>
    </React.Fragment>
  );
};

export default AssignProjectUsers;
